import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { observer } from 'mobx-react';
import { observable, when } from 'mobx';

import messages from './AuthoritiesView.intl';

import styles from './AuthoritiesView.module.scss';

import { Container, Title } from 'common/components/Layout/Layout';
import Authority from './components/Authority/Authority';

import Placeholder from 'common/components/Placeholder/Placeholder';
import AuthoritiesPlaceholder from './placeholder/AuthoritiesPlaceholder';
import ContentStore from 'stores/Content.store';
import InjectMetaTags from 'common/components/InjectMetaTags/InjectMetaTags';

@injectIntl
@observer
export default class AuthoritiesView extends Component {
  management = observable([]);
  boardOfDirectors = observable([]);

  componentDidMount() {
    when(
      () => ContentStore.isLoaded,
      () => {
        this.management.replace(ContentStore.content.homePageManagement);
        this.boardOfDirectors.replace(ContentStore.content.boardOfDirectors);
      }
    );
  }

  render() {
    return (
      <div className={styles.FullWidthContainer}>
        {ContentStore.isLoaded && (
          <InjectMetaTags {...ContentStore.content.authoritiesSEO} />
        )}
        <Container>
          <Title title={this.props.intl.formatMessage(messages.header)} />
          <h2 className={styles.SubTitle}>
            {this.props.intl.formatMessage(messages.management)}
          </h2>
        </Container>
        <Placeholder
          component={<AuthoritiesPlaceholder />}
          ready={ContentStore.isLoaded}
        >
          {this.management.map(el => (
            <Authority
              key={el.person.id}
              name={el.person.fullName}
              position={el.person.position}
              text={el.person.description}
              cite=""
              url={el.person.photo}
              achievements={el.person.professionalAchievements}
              linkedInLink={el.person.linkedInLink}
              cvLink={el.person.pdfLink}
              className={styles.Authority}
            />
          ))}
        </Placeholder>
        <Container>
          <div>
            <h2 className={styles.SubTitle}>
              {this.props.intl.formatMessage(messages.boardOfDirectors)}
            </h2>
            <ul className={styles.ListWrapper}>
              {this.boardOfDirectors.map((el, index) => (
                <li className={styles.Member} key={index}>
                  <div className={styles.MemberName}>
                    {`${el.firstName} ${el.lastName}`}
                  </div>
                  <div className={styles.MemberFile}>
                    <a
                      className={styles.PDFLink}
                      href={el.pdfLink}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {this.props.intl.formatMessage(messages.statement)}
                    </a>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </Container>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Authorities/AuthoritiesView.js